/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

//Capitalize the first letter of a word
export const capitalizeFirst = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
